export default class CommonParams {
  constructor(tdata, exInfo, sdkVersion) {
    this.ev_ver = process.env.EVENT_VERSION;
    this.net_id = tdata?.net_id;
    this.net_key = tdata?.net_key;
    this.prc_net_rq = tdata?.prc_net_rq;
    this.s_prc_fx = tdata?.s_prc_fx;
    this.sdk_ver = sdkVersion;
    this.data = exInfo?.data;
  }

  setCustomerId(customerId) {
    this.ctm_id = customerId;
    return this;
  }

  setEventVersion(eventVersion) {
    this.ev_ver = eventVersion;
    return this;
  }

  setData(data) {
    this.data = data;
    return this;
  }

  setNetworkId(networkId) {
    this.net_id = networkId;
    return this;
  }

  setNetworkKey(networkKey) {
    this.net_key = networkKey;
    return this;
  }

  setPriceNetworkRequest(priceNetworkRequest) {
    this.prc_net_rq = priceNetworkRequest;
    return this;
  }

  setPriceFix(priceFix) {
    this.s_prc_fx = priceFix;
    return this;
  }

  setEventStatus(eventStatus) {
    this.ev_st = eventStatus;
    return this;
  }

  setImpressionType(impressionType) {
    this.imp_tp = impressionType;
    return this;
  }

  setBidder(bidderName) {
    this.bidder = bidderName;
    return this;
  }

  build() {
    return {
      ctm_id: this.ctm_id,
      ev_ver: this.ev_ver,
      data: this.data,
      net_id: this.net_id,
      net_key: this.net_key,
      prc_net_rq: this.prc_net_rq,
      s_prc_fx: this.s_prc_fx,
      ev_st: this.ev_st,
      imp_tp: this.imp_tp,
      bidder: this.bidder,
      sdk_ver: this.sdk_ver,
    };
  }
}
